import { jsx } from 'react/jsx-runtime';
import 'luxon';
import 'react';
import 'styled-components';
import '../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import '../../../theme/ThemedComponentWrapper.js';
import '../../icons/ActivityIcon.js';
import '../../icons/ArrowDownIcon.js';
import '../../icons/ArrowDownRightCircleIcon.js';
import '../../icons/ArrowLeftAlignIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightAlignIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/ArrowSwitchIcon.js';
import '../../icons/ArrowUpIcon.js';
import '../../icons/ArrowUpRightCircleIcon.js';
import '../../icons/ArrowsAngleExpandIcon.js';
import '../../icons/BankIcon.js';
import '../../icons/CheckIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/CrossIcon.js';
import '../../icons/DaiIcon.js';
import '../../icons/DangerIcon.js';
import '../../icons/DownSortIcon.js';
import '../../icons/ExclamationTriangleIcon.js';
import '../../icons/ExpandKpiIcon.js';
import '../../icons/EyeIcon.js';
import '../../icons/EyeSlashIcon.js';
import '../../icons/Grid1x2Icon.js';
import '../../icons/InfoCircleIcon.js';
import '../../icons/ListIcon.js';
import '../../icons/LockIcon.js';
import '../../icons/MediumIcon.js';
import '../../icons/MoonIcon.js';
import '../../icons/PiggyBankIcon.js';
import '../../icons/QuestionMarkCircleIcon.js';
import '../../icons/ShieldIcon.js';
import '../../icons/SunIcon.js';
import '../../icons/UpSortIcon.js';
import '../../icons/XIcon.js';
import '../../atoms/Input/Input.js';
import '../../atoms/ToggleSwitch.js';
import '../../atoms/Table/Table.js';
import '../../atoms/Table/components/HeaderCell/HeaderCell.js';
import '@floating-ui/react';
import '../../atoms/Tooltip/components/TooltipContext.js';
import '../../atoms/Tooltip/components/TooltipContent.js';
import '../../atoms/Tooltip/components/TooltipTrigger.js';
import '../../atoms/Table/components/Pagination/Pagination.js';
import Box from '../../atoms/layout/Box/Box.js';
import '../../atoms/layout/Stack/Stack.js';
import 'ethereum-blockies-base64';
import '../../molecules/CurrencyValue/components/Value.js';
import '../../pictograms/EthPictogram.js';
import '../../pictograms/EtherScanPictogram.js';
import '../../pictograms/DebankPictogram.js';
import '../../pictograms/ZapperPictogram.js';
import '../../pictograms/DaiPictogram.js';
import '../../molecules/TrendValue.js';
import '../../molecules/KpiCard/KpiCard.js';
import '../../molecules/Tabs/Tabs.js';
import './ChartKpi.js';
import '../ChartJS.js';
import '../Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../XRay.js';

function ChartKpiValue({ children, ...rest }) {
    return (jsx(Box, { ...rest, name: "chartKpiValue", children: children }));
}

export { ChartKpiValue as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hhcnRLcGlWYWx1ZS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvY2hhcnRzL0NoYXJ0S3Bpcy9DaGFydEtwaVZhbHVlLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBCb3ggfSBmcm9tICdAaW5kZXgnO1xuaW1wb3J0IHsgQm94UHJvcHMgfSBmcm9tICcuLi8uLi9hdG9tcyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIENoYXJ0S3BpVmFsdWUoeyBjaGlsZHJlbiwgLi4ucmVzdCB9OiBCb3hQcm9wcykge1xuICByZXR1cm4gKFxuICAgIDxCb3ggey4uLnJlc3R9IG5hbWU9XCJjaGFydEtwaVZhbHVlXCI+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9Cb3g+XG4gICk7XG59XG4iXSwibmFtZXMiOlsiX2pzeCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdjLFNBQVUsYUFBYSxDQUFDLEVBQUUsUUFBUSxFQUFFLEdBQUcsSUFBSSxFQUFZLEVBQUE7QUFDbkUsSUFBQSxRQUNFQSxHQUFBLENBQUMsR0FBRyxFQUFBLEVBQUEsR0FBSyxJQUFJLEVBQUUsSUFBSSxFQUFDLGVBQWUsRUFBQSxRQUFBLEVBQ2hDLFFBQVEsRUFBQSxDQUNMLEVBQ047QUFDSjs7OzsifQ==
